import React from 'react';
import styled from 'styled-components';

const TableContainer = styled.div`
  width: 100%;
  margin: 20px 0;
  background-color: ${({ theme }) => (theme === 'dark' ? '#2c3e50' : '#ffffff')};
  border-radius: 12px;
  box-shadow: ${({ theme }) => theme === 'dark' ? '0 8px 20px rgba(0, 0, 0, 0.4)' : '0 4px 10px rgba(0, 0, 0, 0.1)'};
  padding: 20px;
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const TableHeader = styled.th`
  padding: 14px 20px;
  color: ${({ theme }) => (theme === 'dark' ? '#ecf0f1' : '#2c3e50')};
  background-color: ${({ theme }) => (theme === 'dark' ? '#34495e' : '#f7f9fb')};
  text-align: left;
  font-size: 1.1rem;
  font-weight: 600;
  border-bottom: 2px solid ${({ theme }) => (theme === 'dark' ? '#2c3e50' : '#e0e0e0')};
  letter-spacing: 0.5px;
`;

const TableCell = styled.td`
  padding: 12px 20px;
  color: ${({ theme }) => (theme === 'dark' ? '#ecf0f1' : '#2c3e50')};
  font-size: 1rem;
  border-bottom: 1px solid ${({ theme }) => (theme === 'dark' ? '#7f8c8d' : '#f1f1f1')};
  transition: background-color 0.3s ease;
  letter-spacing: 0.5px;

  &:hover {
    background-color: ${({ theme }) => (theme === 'dark' ? '#34495e' : '#fafafa')};
  }
`;

const TableRow = styled.tr`
  background-color: ${({ theme, isEven }) =>
        theme === 'dark' ? (isEven ? '#34495e' : '#2c3e50') : '#ffffff'};
`;

const TableComponent = ({ data, theme }) => {
    return (
        <TableContainer theme={theme}>
            <Table>
                <thead>
                    <tr>
                        <TableHeader theme={theme}>Label</TableHeader>
                        <TableHeader theme={theme}>Value</TableHeader>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <TableRow key={index} theme={theme} isEven={index % 2 === 0}>
                            <TableCell theme={theme}>{item.label}</TableCell>
                            <TableCell theme={theme}>{item.value}</TableCell>
                        </TableRow>
                    ))}
                </tbody>
            </Table>
        </TableContainer>
    );
};

export default TableComponent;
